// pagination.mjs
export function paginate() {
	const itemsPerPage = 6;
	const items = document.querySelectorAll('.map__item');
	let currentPage = 1;
	let prevBtn;
	let nextBtn;
	createButtons();

	function createButtons() {
		let container = document.querySelector(".map__pagination");
		let html = container.innerHTML;
		container.innerHTML = html;
		prevBtn = container.querySelector(".item--prev");
		nextBtn = container.querySelector(".item--next");
	}

	function getActive() {
		return document.querySelectorAll(".map__item.active");
	}

	function showPage(page) {
		const startIndex = (page - 1) * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;

		// Hide all items first
		items.forEach(item => item.classList.remove("visible"));
		let active = getActive();

		// Show items for the current page
		for (let i = startIndex; i < endIndex && i < active.length; i++) {
			active[i].classList.add("visible");
		}

		// Update button states
		updateButtonStates(page, endIndex);
	}

	function updateButtonStates(page, endIndex) {
		// reset
		prevBtn.classList.remove("disabled");
		nextBtn.classList.remove("disabled");
		let active = getActive();
		// set
		if (page === 1) {
			prevBtn.classList.add("disabled");
		}
		if (endIndex >= active.length) {
			nextBtn.classList.add("disabled");
		}
	}
	function nextButton(e) {
		e.preventDefault();
		if (e.target.classList.contains("disabled")) return;
		currentPage++;
		showPage(currentPage);
	}
	function prevButton(e) {
		e.preventDefault();
		if (e.target.classList.contains("disabled")) return;
		currentPage--;
		showPage(currentPage);
	}
	function setupPagination() {
		nextBtn.addEventListener('click', nextButton);
		prevBtn.addEventListener('click', prevButton);

		// Initial display
		showPage(currentPage);
	}
	setupPagination();
}


